import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RegistrationStatus } from '@/contracts';
import { localStorage, StorageKey } from '@bimdata/client';

export type RegistrationState = {
  claimId: string | null;
  withPhone: boolean | null;
  phoneClaimExpires?: Date,
  status: RegistrationStatus;
};

type Claim = {
  id: string;
  phoneTtl: number;
}

export default createSlice({
  name: 'registration',
  initialState: () => {
    let claimId = localStorage.get(StorageKey.REGISTRATION_CLAIM_ID_KEY) || null;
    let withPhone = localStorage.get(StorageKey.REGISTRATION_WITH_PHONE_KEY) === 'true';
    if (withPhone) {
      const expires = new Date(localStorage.get(StorageKey.REGISTRATION_WITH_PHONE_EXPIRES_KEY) || '1970-01-01');
      if (+expires < Date.now()) {
        claimId = null;
        withPhone = false;
        localStorage.remove(StorageKey.REGISTRATION_WITH_PHONE_KEY);
        localStorage.remove(StorageKey.REGISTRATION_WITH_PHONE_EXPIRES_KEY);
      }
    }
    return {
      claimId,
      withPhone,
      status: claimId
        ? RegistrationStatus.CONFIRMATION
        : RegistrationStatus.PENDING
    } as RegistrationState;
  },
  reducers: {
    startRegistration: (
      state: RegistrationState,
      { payload }: PayloadAction<{ withPhone: boolean }>
    ) => {
      state.status = RegistrationStatus.PROCESSING;
      state.withPhone = payload.withPhone;
      localStorage.remove(StorageKey.REGISTRATION_CLAIM_ID_KEY);
      if (state.withPhone) {
        localStorage.set(StorageKey.REGISTRATION_WITH_PHONE_KEY, 'true');
      } else {
        localStorage.remove(StorageKey.REGISTRATION_WITH_PHONE_KEY);
      }
    },
    fakeFinishRegistration: (state: RegistrationState) => {
      state.status = RegistrationStatus.CONFIRMATION;
    },
    finishRegistration: (state: RegistrationState, { payload }: PayloadAction<Claim>) => {
      state.status = RegistrationStatus.CONFIRMATION;
      state.claimId = payload.id;
      state.phoneClaimExpires = new Date(+(new Date()) + payload.phoneTtl * 1000);
      localStorage.set(StorageKey.REGISTRATION_WITH_PHONE_EXPIRES_KEY, `${state.phoneClaimExpires}`);
      localStorage.set(StorageKey.REGISTRATION_CLAIM_ID_KEY, payload.id);
    },
    rejectRegistration: (state: RegistrationState) => {
      state.status = RegistrationStatus.PENDING;
    },
    reset: (state: RegistrationState) => {
      state.status = RegistrationStatus.PENDING;
      state.claimId = null;
      state.withPhone = null;
      localStorage.remove(StorageKey.REGISTRATION_CLAIM_ID_KEY);
      localStorage.remove(StorageKey.REGISTRATION_WITH_PHONE_KEY);
    },
    confirmed: (state: RegistrationState) => {
      state.status = RegistrationStatus.CONFIRMED;
      state.claimId = null;
      state.withPhone = null;
      localStorage.remove(StorageKey.REGISTRATION_CLAIM_ID_KEY);
      localStorage.remove(StorageKey.REGISTRATION_WITH_PHONE_KEY);
    }
  }
});
